import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const PermittedIPList = styled.div`
  height: 150px;
  overflow-y: auto;
  justify-content: start;
  padding-top: 5px;
  padding-bottom: 5px;
`;
export const IpAddressInputWrapper = styled.div`
  padding-left: 5px;
`;
export const StyledTextInput = styled.input`
  width: 180px;
  height: 23px;
  border: 1px solid #acacac;
  background-color: ${ColorSF2.whisperGray};
  border-color: ${ColorSF2.mediumGray};
  margin: 3px 5px;
  padding-left: 5px;
`;
export const StyledButton = styled.button`
  width: 64px;
  height: 24px;
  margin: 3px 5.5px;
  background-color: ${ColorSF2.white};
  border: 1px solid ${ColorSF2.mediumGray};
  border-radius: 6px;
  cursor: pointer;
`;
export const ErrorMessage = styled.p`
  color: ${ColorSF2.alertRed};
  font-size: 0.8rem;
  padding-left: 10px;
`;
